import { render, staticRenderFns } from "./r-pagination-new.vue?vue&type=template&id=086afcc6"
import script from "./r-pagination-new.vue?vue&type=script&setup=true&lang=js"
export * from "./r-pagination-new.vue?vue&type=script&setup=true&lang=js"
import style0 from "./r-pagination-new.vue?vue&type=style&index=0&id=086afcc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports